/**
 * Parity with src/js/objects/global/fitting-room.js — URL + localStorage instore mode.
 */
const STORAGE_KEY = 'instore';
/** `undefined` = not read yet; avoids repeat localStorage reads (value rarely changes). */
let cachedInstoreMode = undefined;
function setCachedInstoreMode(mode) {
    cachedInstoreMode = mode;
    return mode;
}
export function syncInstoreModeFromUrl(search) {
    if (typeof window === 'undefined')
        return null;
    const params = new URLSearchParams(search !== null && search !== void 0 ? search : window.location.search);
    const instoreParam = params.get('instore');
    if (!instoreParam && !localStorage.getItem(STORAGE_KEY)) {
        return setCachedInstoreMode(null);
    }
    if (instoreParam === 'off') {
        localStorage.removeItem(STORAGE_KEY);
        return setCachedInstoreMode(null);
    }
    if (instoreParam === 'on' || instoreParam === 'styling') {
        localStorage.setItem(STORAGE_KEY, instoreParam);
        return setCachedInstoreMode(instoreParam);
    }
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'on' || stored === 'styling') {
        return setCachedInstoreMode(stored);
    }
    return setCachedInstoreMode(null);
}
export function getInstoreModeFromStorage() {
    if (typeof window === 'undefined')
        return null;
    if (cachedInstoreMode !== undefined)
        return cachedInstoreMode;
    const stored = localStorage.getItem(STORAGE_KEY);
    const mode = stored === 'on' || stored === 'styling' ? stored : null;
    cachedInstoreMode = mode;
    return mode;
}
